import React from "react";
import { View, Text } from "react-native";
import { CommonButton } from "../../components/buttons";
import { fonts } from "../../common/styles/fonts";
import { useNavigate } from "react-router-dom";
import { MascotSubscribeStarter } from "../../common/icons/mascot_subscribe_starter";
import { CommonScreenCard } from "../../components/CommonScreenCard";
import { useIsDesktop } from "../../utils/useIsDesktop";
export const LandingSubscriptionPage = () => {
  const navigate = useNavigate();

  const isDesktop: boolean = useIsDesktop();
  return (
    <CommonScreenCard
      screenStyle={{ justifyContent: "center" }}
      style={isDesktop && { justifyContent: "center" }}
    >
      <MascotSubscribeStarter style={{ marginBottom: 32 }} />
      <Text style={[fonts.title, { marginBottom: 48 }]}>Welcome customer!</Text>
      <View style={{ flexDirection: "column" }}>
        <CommonButton
          textStyle={fonts.mediumText_bold}
          title="Login"
          type="blackFilled"
          containerStyle={{ width: 170, marginBottom: 12 }}
          onPress={() => navigate("../subscription/login")}
        />
        <CommonButton
          textStyle={fonts.mediumText_bold}
          title="Registration"
          type="black"
          containerStyle={{ width: 170 }}
          onPress={() => navigate("../subscription/register")}
        />
      </View>
    </CommonScreenCard>
  );
};
